import React, { useState, useEffect } from 'react';
import PricingGrid from '../components/subscription/PricingGrid';
import SuccessDisplay from '../components/subscription/SuccessDisplay';
import Message from '../components/subscription/Message';

export default function SubscribePage() {
  const [message, setMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get('success')) {
      setSuccess(true);
      setSessionId(query.get('session_id'));
    }

    if (query.get('canceled')) {
      setSuccess(false);
      setMessage(
        "Subscription canceled — you can try again when you're ready."
      );
    }
  }, [sessionId]);

  if (success && sessionId !== '') {
    return <SuccessDisplay sessionId={sessionId} />;
  } else if (!success && message !== '') {
    return <Message message={message} />;
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <PricingGrid />
    </div>
  );
}
